import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  inject,
  input,
  NgZone,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { takeUntil, tap, timer } from 'rxjs';
import { DateFormatPipe, TimeFormatPipe } from '@cue/pipes';
import { injectDestroy } from 'ngxtension/inject-destroy';
import { Title } from '@angular/platform-browser';
import { FaviconService } from '@cue/utilities';

@Component({
  selector: 'cue-kiosk-now',
  imports: [],
  templateUrl: './kiosk-now.component.html',
  styleUrl: './kiosk-now.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [TimeFormatPipe, DateFormatPipe],
})
export class KioskNowComponent implements OnInit, OnDestroy {
  #zone = inject(NgZone);
  #terminator = injectDestroy();
  #timeFormatPipe = inject(TimeFormatPipe);
  #dateFormatPipe = inject(DateFormatPipe);
  #elRef = inject(ElementRef);
  #title = inject(Title);
  #faviconService = inject(FaviconService);

  title = input<string | null>(null);
  favIcon = input<string | null>(null);

  private renderTime() {
    this.#zone.runOutsideAngular(() => {
      timer(0, 1000)
        .pipe(
          takeUntil(this.#terminator),
          tap(() => {
            const time = '<b>' + this.#timeFormatPipe.transform(new Date()) + '</b>';
            const date = this.#dateFormatPipe.transform(new Date());
            this.#elRef.nativeElement.innerHTML = time + ' ' + date;
          })
        )
        .subscribe();
    });
  }

  ngOnInit() {
    this.renderTime();

    this.#title.setTitle(this.title());
    this.#faviconService.setFavicon(this.favIcon());
  }

  ngOnDestroy() {
    this.#faviconService.resetFavicon();
  }
}
